import React from 'react';
import { Col, FormGroup, Label, ButtonGroup, Button } from 'reactstrap';
import { Field } from 'formik';
import './CheckSimNao.css';

export const CheckSimNao = ({ name, label, col, disabled, readOnly, onChange }) => {
    return (
        <Col md={col}>
            <FormGroup>
                <Label className="check-sim-nao-label">{label}</Label>
                <Field name={name}>
                    {({ field, form }) => {
                        const currentValue = field.value;

                        const handleClick = (newValue) => {
                            if (disabled || readOnly) return;

                            form.setFieldValue(name, newValue);

                            if (onChange) {
                                onChange(newValue);
                            }
                        };

                        return (
                            <div className="check-sim-nao-container">
                                <ButtonGroup className="w-100">
                                    <Button
                                        type="button"
                                        color={currentValue === true ? 'dark' : 'light'}
                                        onClick={() => handleClick(true)}
                                        active={currentValue === true}
                                        disabled={disabled || readOnly}
                                        className="check-sim-nao-btn"
                                    >
                                        Sim
                                    </Button>
                                    <Button
                                        type="button"
                                        color={currentValue === false ? 'dark' : 'light'}
                                        onClick={() => handleClick(false)}
                                        active={currentValue === false}
                                        disabled={disabled || readOnly}
                                        className="check-sim-nao-btn"
                                    >
                                        Não
                                    </Button>
                                </ButtonGroup>
                            </div>
                        );
                    }}
                </Field>
            </FormGroup>
        </Col>
    );
};

CheckSimNao.defaultProps = {
    col: 12,
    disabled: false,
    readOnly: false,
    onChange: null
};
